import React from 'react';
type Tone = 'paper' | 'paperDark' | 'navy';
interface SectionBandProps {
  id?: string;
  tone?: Tone;
  /** Max width of the inner content container. */
  width?: 'narrow' | 'default' | 'wide';
  /** Vertical padding. `tight` is ~⅔ of default for short transitions. */
  spacing?: 'default' | 'tight';
  className?: string;
  children: React.ReactNode;
}
const toneClass: Record<Tone, string> = {
  paper: 'bg-[#faf8f5] text-[#2d3e52]',
  paperDark: 'bg-[#f5f3f0] text-[#2d3e52] border-y border-gray-200/70',
  navy: 'bg-[#1a2838] text-[#faf8f5]'
};
const widthClass = {
  narrow: 'max-w-3xl',
  default: 'max-w-5xl',
  wide: 'max-w-6xl'
};
const spacingClass = {
  default: 'px-6 py-20 md:px-10 md:py-28',
  tight: 'px-6 py-14 md:px-10 md:py-20'
};
export function SectionBand({
  id,
  tone = 'paper',
  width = 'default',
  spacing = 'default',
  className = '',
  children
}: SectionBandProps) {
  return <section id={id} className={`${spacingClass[spacing]} ${toneClass[tone]} ${className}`} data-id="element-888" data-mp="34lr7dnzsyqin">
      <div className={`mx-auto ${widthClass[width]}`} data-id="element-889" data-mp="dz9tupsjmqve">{children}</div>
    </section>;
}

/** Small uppercase eyebrow label used to open sections consistently. */
export function Eyebrow({
  children,
  tone = 'seaglass'
}: {
  children: React.ReactNode;
  tone?: 'seaglass' | 'muted';
}) {
  return <p className={`text-xs font-semibold uppercase tracking-[0.22em] ${tone === 'seaglass' ? 'text-seaglass' : 'text-text-muted'}`} data-id="element-890" data-mp="iymh3bnbtzyi">
      {children}
    </p>;
}